// Section ID 599630 is the single section within menu 109920 (Beer Belly Cologne)
const UNTAPPD_URL = 'https://business.untappd.com/api/v1/sections/599630/items';
const UNTAPPD_AUTH = 'Basic ' + btoa('beerbelly.cologne@gmail.com:x2mQFfTnxcyUnuSseTsf');
const STAR_BASE = 'https://assets.untappd.com/assets/images/ratings/';

// Single shared promise — all product instances on the page share one fetch
let ratingsPromise = null;

const fetchRatings = () => {
  if (!ratingsPromise) {
    ratingsPromise = fetch(UNTAPPD_URL, { headers: { 'Authorization': UNTAPPD_AUTH } })
      .then(res => res.json())
      .then(data => data.items || [])
      .catch(() => []);
  }
  return ratingsPromise;
};

const buildStars = (rating) => {
  const full = Math.floor(rating);
  const decimal = rating - full;
  let html = '';

  for (let i = 1; i <= 5; i++) {
    let cap;
    if (i <= full) {
      cap = 'cap-100';
    } else if (i === full + 1 && decimal > 0) {
      const pct = Math.min(100, Math.max(10, Math.round(decimal * 10) * 10));
      cap = `cap-${pct}`;
    } else {
      cap = 'cap';
    }
    html += `<img src="${STAR_BASE}${cap}@2x.png" class="untappd-star" alt="" loading="lazy">`;
  }

  return html;
};

const renderContainer = (el) => {
  // Mark immediately to prevent re-entry from rapid observer firings
  if (el.dataset.loaded) return;
  el.dataset.loaded = 'true';

  const title = (el.dataset.productTitle || '').toLowerCase();
  if (!title) return;

  fetchRatings().then(items => {
    const match = items.find(item => title.includes(item.original_name.toLowerCase()));
    if (!match) return;

    const rating = parseFloat(match.rating);
    el.innerHTML = `
      <div class="untappd-rating__inner">
        <span class="untappd-rating__label">Untappd (${match.rating_count} Ratings)</span>
        <div class="untappd-rating__stars">
          ${buildStars(rating)}
          <span class="untappd-rating__score">${rating.toFixed(2)}</span>
        </div>
      </div>
    `;
  });
};

const renderAll = () => {
  document.querySelectorAll('.untappd-rating-container:not([data-loaded])').forEach(renderContainer);
};

// One shared debounced MutationObserver for the whole page
let debounceTimer;
new MutationObserver(() => {
  clearTimeout(debounceTimer);
  debounceTimer = setTimeout(renderAll, 300);
}).observe(document.body, { childList: true, subtree: true });

// Initial run — handles both early and late script execution
if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', renderAll);
} else {
  renderAll();
}
